export default {
  INVOICE_STATUS: [{
    id: 1,
    name: '申请中',
    color: 'primary'
  }, {
    id: 2,
    name: '开票中',
    color: 'warning'
  }, {
    id: 3,
    name: '已开票',
    color: 'success'
  }, {
    id: 4,
    name: '作废',
    color: 'danger'
  }, {
    id: 5,
    name: '取消',
    color: 'danger'
  }],
  INVOICE_COMPANY: [{
    id: 1,
    name: '汇力发'
  }, {
    id: 2,
    name: '御茶膳房'
  }],
  INVOICE_TYPE: [{
    id: 1,
    name: '电子发票'
  }, {
    id: 2,
    name: '纸质发票'
  }],
  MEMBER_INVOICE_TYPE: [{
    id: 1,
    name: '个人'
  }, {
    id: 2,
    name: '企业'
  }],
  PRINT_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '未打印',
    color: 'info'
  }, {
    id: 2,
    name: '已打印',
    color: 'success'
  }],
  QUALITY_STATUS: [{
    id: 1,
    name: '待质检',
    color: 'info'
  }, {
    id: 2,
    name: '合格',
    color: 'success'
  }, {
    id: 3,
    name: '不合格',
    color: 'danger'
  }],
  PRODUCE_ORDER_TYPE: [{
    id: 1,
    name: '中转库'
  }, {
    id: 2,
    name: '生产工厂'
  }],
  PRODUCE_STATUS: [{
    id: 1,
    name: '待处理',
    color: 'info'
  }, {
    id: 2,
    name: '开始制作',
    color: 'warning'
  }, {
    id: 3,
    name: '制作完成',
    color: 'success'
  }, {
    id: 4,
    name: '取消制作',
    color: 'danger'
  }, {
    id: 5,
    name: '申请作废',
    color: 'info'
  }, {
    id: 6,
    name: '已作废',
    color: 'danger'
  }],
  SELL_ORDER_STATUS: [{
    id: 1,
    name: '订单录入',
    color: 'info'
  }, {
    id: 2,
    name: '订单处理',
    color: 'info'
  }, {
    id: 3,
    name: '开始制作',
    color: 'warning'
  }, {
    id: 4,
    name: '制作完成',
    color: 'success'
  }, {
    id: 5,
    name: '质检完成',
    color: 'success'
  }, {
    id: 6,
    name: '备货完成',
    color: 'success'
  }, {
    id: 7,
    name: '订单送出',
    color: 'success'
  }, {
    id: 8,
    name: '订单送达',
    color: 'success'
  }, {
    id: 9,
    name: '已经收款',
    color: 'success'
  }, {
    id: 10,
    name: '订单取消',
    color: 'danger'
  }],
  REQUIRE_ORDER_STATUS: [{
    id: 1,
    name: '订单录入',
    color: 'info'
  }, {
    id: 2,
    name: '订单处理',
    color: 'info'
  }, {
    id: 3,
    name: '开始制作',
    color: 'warning'
  }, {
    id: 4,
    name: '制作完成',
    color: 'success'
  }, {
    id: 5,
    name: '质检完成',
    color: 'success'
  }, {
    id: 6,
    name: '备货完成',
    color: 'success'
  }, {
    id: 7,
    name: '订单送出',
    color: 'success'
  }, {
    id: 8,
    name: '订单送达',
    color: 'success'
  }, {
    id: 9,
    name: '订单收货',
    color: 'success'
  }, {
    id: 10,
    name: '订单取消',
    color: 'danger'
  }],
  SALE_ORDER_STATUS: [{
    id: 1,
    name: '订单录入',
    color: 'info'
  }, {
    id: 2,
    name: '确认',
    color: 'success'
  }],
  ORDERER_TYPE: [{
    id: 1,
    name: '渠道商'
  }, {
    id: 2,
    name: '会员'
  }],
  STORAGE_TYPE: [{
    id: 1,
    name: '普通库房'
  }, {
    id: 2,
    name: '中转库'
  }],
  PAY_AGREED: [{
    id: 1,
    name: '货到付款'
  }, {
    id: 2,
    name: '月结'
  }, {
    id: 3,
    name: '提前付款（款已付）'
  }, {
    id: 4,
    name: '银行转账'
  }],
  PURCHASE_ORDER_STATUS: [{
    id: 1,
    name: '待采购',
    color: 'info'
  }, {
    id: 2,
    name: '采购中',
    color: 'warning'
  }, {
    id: 3,
    name: '采购完成',
    color: 'success'
  }],
  APPROVE_TYPE: [{
    id: 1,
    name: '凭票付款'
  }, {
    id: 2,
    name: '先款后票'
  }],
  APPROVE_OP_FLOW: [{
    id: 1,
    name: '会签'
  }, {
    id: 2,
    name: '或签'
  }],
  APPROVE_STATUS: [{
    id: 1,
    name: '已申请'
  }, {
    id: 2,
    name: '已审批'
  }, {
    id: 3,
    name: '已驳回'
  }],
  APPROVE_PAY_STATUS: [{
    id: 1,
    name: '无需打款'
  }, {
    id: 2,
    name: '待打款'
  }, {
    id: 3,
    name: '已打款'
  }],
  APPROVE_GET_INVOICE_STATUS: [{
    id: 1,
    name: '无需回票'
  }, {
    id: 2,
    name: '需回票'
  }, {
    id: 3,
    name: '已回票'
  }],
  APPROVE_TYPE: [{
    id: 1,
    name: '凭票付款'
  }, {
    id: 2,
    name: '先款后票'
  }],
  APPROVE_PURCHASE_ORDER_STATUS: [{
    id: 0,
    name: '待审批',
    color: 'info'
  }, {
    id: 1,
    name: '待审批',
    color: 'info'
  }, {
    id: 2,
    name: '审批通过',
    color: 'success'
  }, {
    id: 3,
    name: '审批拒绝',
    color: 'danger'
  }],
  PURCHASE_ORDER_FINANCE_STATUS: [{
    id: 1,
    name: '未确认',
    color: 'info'
  }, {
    id: 2,
    name: '部分确认',
    color: 'warning'
  }, {
    id: 3,
    name: '全部确认',
    color: 'success'
  }],
  PURCHASE_INBOUND_STATUS: [{
    id: 1,
    name: '待入库',
    color: 'info'
  }, {
    id: 2,
    name: '锁定',
    color: 'warning'
  }, {
    id: 3,
    name: '已入库',
    color: 'success'
  }],
  PURCHASE_UN_INBOUND_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '待退货',
    color: 'info'
  }, {
    id: 2,
    name: '已退货',
    color: 'success'
  }],
  OUTBOUND_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '待出库',
    color: 'info'
  }, {
    id: 3,
    name: '已出库',
    color: 'success'
  }],
  UN_OUTBOUND_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '待退货'
  }, {
    id: 2,
    name: '退货完成'
  }],
  ALLOCATION_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '待出库'
  }, {
    id: 2,
    name: '出库完成'
  }, {
    id: 3,
    name: '入库完成'
  }],
  TAKING_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '盘点中'
  }, {
    id: 2,
    name: '盘点完成'
  }],
  PRESET_PRICE_LEVEL: [{
    id: 1,
    name: '一级'
  }, {
    id: 2,
    name: '二级'
  }, {
    id: 3,
    name: '三级'
  }],
  STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '启用'
  }, {
    id: 2,
    name: '停用'
  }],
  GOODS_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '上架中'
  }, {
    id: 2,
    name: '已下架'
  }],
  // 性别
  EMPLOYEE_STATUS: [{
    id: null,
    name: '全部'
  }, {
    id: 1,
    name: '在职'
  }, {
    id: 2,
    name: '离职'
  }],
  // 性别
  ORDER_DATE_TYPE: [{
    id: '1',
    name: '按送货日期'
  }, {
    id: '2',
    name: '按订单日期'
  }, {
    id: '3',
    name: '按收款日期'
  }],
  // 性别
  SEX: [{
    id: '1',
    name: '男'
  }, {
    id: '2',
    name: '女'
  }],
  // 是否
  YES_NO: [{
    id: 1,
    name: '是'
  }, {
    id: 2,
    name: '否'
  }],
  /**
   * 基础
   * */
  ORDER_BILL_DEFAULT_ROWS: 6,
  SALES_ORDER_DEFAULT_ROWS: 3,
  ORDER_BILL_TYPES: [{
    id: null,
    name: '全部单据'
  }, {
    id: 1,
    name: '采购单'
  }, {
    id: 2,
    name: '采购退货'
  }, {
    id: 3,
    name: '生产单'
  }, {
    id: 4,
    name: '生产退货'
  }, {
    id: 5,
    name: '入库单'
  }, {
    id: 6,
    name: '出库单'
  }, {
    id: 7,
    name: '销售预订单'
  }, {
    id: 8,
    name: '销售退货'
  }, {
    id: 9,
    name: '配送单'
  }, {
    id: 10,
    name: '门店备货单'
  }, {
    id: 11,
    name: '报损单'
  }, {
    id: 12,
    name: '报溢单'
  }, {
    id: 13,
    name: '调拨单'
  }, {
    id: 20,
    name: '销售单'
  }, {
    id: 51,
    name: '付款单'
  }, {
    id: 52,
    name: '收款单'
  }, {
    id: 99,
    name: '盘点单'
  }],
  PREV_ORDER_BILL_TYPES: [{
    id: 1,
    name: '采购'
  }, {
    id: 2,
    name: '生产'
  }],
  PREV_OUTBOUND_ORDER_TYPES: [{
    id: 1,
    name: '销售'
  }, {
    id: 2,
    name: '生产'
  }],
  EVENT_TYPES: [{
    id: 1,
    name: '产品'
  }],
  NOTICE_TYPES: [{
    id: 1,
    name: '事件'
  }, {
    id: 2,
    name: '时间'
  }],
  NOTICE_STATUS: [{
    id: 1,
    name: '未读',
    color: 'info'
  }, {
    id: 2,
    name: '已读',
    color: 'success'
  }],
  UPLOAD: {
    IMAGE_TYPES: ['jpg', 'png', 'jpeg', 'bmp'],
    IMG_WIDTH_LIMIT: 1024,
    IMG_HEIGHT_LIMIT: 1024
  },
  TIP: {
    TITLE: '系统提示',
    SELECT_ONE_FIRST: '请您选择一项，再进行操作',
    SELECT_ONE_LEAST: '请您至少选择一项，再进行操作',
    NO_OPERATION_RECORDS: '无可操作的数据'
  },
  PRINT_SETTINGS: {
    PRINT_COUNT_OF_PRODUCE_ORDER: 6
  },
  // 分页信息
  PAGINATION: {
    TOTAL: 0,
    PAGE: 1,
    ROWS: 10,
    MAX_ROWS: 99999999
  },
  // 默认小数保留位
  DECIMAL: {
    DEFAULT_PRECISION: 2,
    DEFAULT_SPEC_PRECISION: 4,
    DEFAULT_MAX_NUM: 9999999.99,
    DEFAULT_SPEC_MAX_NUM: 9999999.9999
  },
  SEND_SMS_INTERVAL: 60, // 获取短信时间间隔（s）
  EVENT_INTERVAL: 30, // 特殊事件轮循时间周期（s）
  NOTICE_INTERVAL: 60, // 消息轮循时间周期（s）

  WXFWH: {
    APPID: 'wxf8aed4aa964655d9'
  },

  AGENT_MAP: {
    '/sell/order': 1000004,
    '/sell/order-manage': 1000004,
    '/sell/report-by-date': 1000004,
    '/require/order': 1000004,
    '/require/order-manage': 1000004,
    '/sale/order': 1000004,
    '/sale/order-manage': 1000004,
    '/bind-produce/un-quality': 1000009,
    '/bind-produce/track-bind': 1000008,
    '/produce/order-manage': 1000008,
    '/delivery/issued': 1000008,
    '/delivery/require-issued': 1000004,
    '/delivery/arrived': 1000008,
    '/delivery/require-arrived': 1000004,
    '/delivery/report': 1000008,
    '/delivery/order-list': 1000008,
    '/stock/goods-storage': 1000004,
    '/purchase/order-detail': 1000021,
    '/approve-info/apply': 1000022,
    '/approve-info/manage': 1000022,
    '/approve-info/detail': 1000022
  },
  IMAGE_TYPES: ['jpg', 'png', 'jpeg', 'bmp'],
  EMPTY_MSG: '暂无数据',
  IMG_WIDTH_LIMIT: 1024,
  IMG_HEIGHT_LIMIT: 1024,
  // uncheck permissions whitelist
  UNCHECK_PERMISSIONS_WHITE_LIST: ['admin', 'sysadmin'],
  COMPANY_NAME: '北京御茶膳房食品有限责任公司',
  SYSTEM_NAME: '御茶膳房综合运营管理系统',
  SYSTEM_SNAME: '御茶膳房'
}



// WEBPACK FOOTER //
// ./src/utils/const.js